import lozad from "lozad";

export default defineNuxtPlugin({
  setup: (nuxtApp) => {
    nuxtApp.provide("lozad", lozad);
  },
  parallel: true
});
